"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
const lodash_1 = require("lodash");
const operators_1 = require("rxjs/operators");
const Pin_1 = require("../Pin");
const AudioComponent_1 = require("./audio/AudioComponent");
const DropzoneComponent_1 = require("./dropzone/DropzoneComponent");
const FormulaComponent_1 = require("./formula/FormulaComponent");
const HotspotComponent_1 = require("./hotspot/HotspotComponent");
const ImageComponent_1 = require("./image/ImageComponent");
const SpinnerComponent_1 = require("./spinner/SpinnerComponent");
const SymbolComponent_1 = require("./symbol/SymbolComponent");
const TableComponent_1 = require("./table/TableComponent");
const TextComponent_1 = require("./text/TextComponent");
const TimerComponent_1 = require("./timer/TimerComponent");
const TrafficLightComponent_1 = require("./trafficLight/TrafficLightComponent");
const VideoComponent_1 = require("./video/VideoComponent");
var Component;
(function (Component) {
    function getSetting(comp, setting) {
        const settings = comp.settings;
        if (settings && settings[setting] !== undefined)
            return settings[setting];
    }
    Component.getSetting = getSetting;
    // TODO: playerdata should always have students
    function playerData(data) {
        return {
            students: data.students && data.students.length ? data.students : [],
        };
    }
    Component.playerData = playerData;
    function fromPin(pin, componentId) {
        const components = pin.pinComponents || [];
        return components.find((c) => c.id === componentId);
    }
    Component.fromPin = fromPin;
    function index(pin, componentId) {
        const components = pin.pinComponents || [];
        return components.findIndex((c) => c.id === componentId);
    }
    Component.index = index;
    function playerDataStream(obs) {
        return obs.pipe((0, operators_1.map)((data) => playerData(data)), (0, operators_1.distinctUntilChanged)(lodash_1.isEqual));
    }
    Component.playerDataStream = playerDataStream;
    function isBox(position) {
        return 'bottom' in position && 'right' in position;
    }
    Component.isBox = isBox;
    function isPortraitInDom(bbox) {
        return bbox.width * Pin_1.Pin.aspectRatio.width > bbox.height * Pin_1.Pin.aspectRatio.height;
    }
    Component.isPortraitInDom = isPortraitInDom;
    function getBBox(position) {
        const { left, right, top, bottom } = position;
        const width = 100 - left - right;
        const height = 100 - top - bottom;
        return {
            left,
            right,
            top,
            bottom,
            height,
            width,
            center: {
                x: left + width / 2,
                y: top + height / 2,
            },
        };
    }
    Component.getBBox = getBBox;
    function isAudio(comp) {
        return comp.type === 'audio';
    }
    Component.isAudio = isAudio;
    function isImage(comp) {
        return comp.type === 'image';
    }
    Component.isImage = isImage;
    function isVideo(comp) {
        return comp.type === 'video';
    }
    Component.isVideo = isVideo;
    function isText(comp) {
        return comp.type === 'text';
    }
    Component.isText = isText;
    function isTimer(comp) {
        return comp.type === 'timer';
    }
    Component.isTimer = isTimer;
    function isHotspot(comp) {
        return comp.type === 'hotspot';
    }
    Component.isHotspot = isHotspot;
    function isSymbol(comp) {
        return comp.type === 'symbol';
    }
    Component.isSymbol = isSymbol;
    function isTable(comp) {
        return comp.type === 'table';
    }
    Component.isTable = isTable;
    function isDropzone(comp) {
        return comp.type === 'dropzone';
    }
    Component.isDropzone = isDropzone;
    function isFormula(comp) {
        return comp.type === 'formula';
    }
    Component.isFormula = isFormula;
    function fontsForComponent(component) {
        if (isText(component)) {
            return [component.settings.fontFamily];
        }
        if (isTable(component)) {
            return [component.settings.fontFamily];
        }
        return [];
    }
    Component.fontsForComponent = fontsForComponent;
    function firstText(components) {
        const TextComponents = components.filter(Component.isText);
        for (const comp of TextComponents) {
            if (comp.settings.text) {
                return comp.settings.text;
            }
        }
    }
    Component.firstText = firstText;
    const componentsWithAdjustableRatio = ['text', 'image', 'video', 'dropzone'];
    function isFixedAspectRatio(component) {
        if (component.type === 'symbol') {
            return SymbolComponent_1.SymbolComponent.symbolForName(component.settings.symbol).startWithFixedAspectRatio;
        }
        return !componentsWithAdjustableRatio.includes(component.type);
    }
    Component.isFixedAspectRatio = isFixedAspectRatio;
    function isAdjustableAspectRatio(component) {
        return !isFixedAspectRatio(component);
    }
    Component.isAdjustableAspectRatio = isAdjustableAspectRatio;
    const rotatable = ['text', 'image', 'symbol'];
    function canRotate(component) {
        return rotatable.includes(component.type);
    }
    Component.canRotate = canRotate;
    function canOnlyScaleHorizontally(component) {
        return ['table'].includes(component.type);
    }
    Component.canOnlyScaleHorizontally = canOnlyScaleHorizontally;
    function isPartOfDragQuestion(component) {
        return !!component.settings?.isDraggable;
    }
    Component.isPartOfDragQuestion = isPartOfDragQuestion;
    // TODO: Remove?
    // export function cloneWithRelations(item: PinItem) {
    //   if (!item || !item.components || !item.components.length) return [];
    //   const { components } = item;
    //   const newIds: Record<string, string> = {};
    //   // generate clones from old list.
    //   // TODO @davey: remove any
    //   const newComponents: Component.All[] = components.map((c: any) => {
    //     // new Ids
    //     const id = randomId();
    //     // create mapping from old ids to new
    //     newIds[c._id] = id;
    //     const c2 = _.cloneDeep(c);
    //     c2._id = id;
    //     return c2;
    //   });
    //   // fix for media triggers
    //   newComponents.forEach((c) => {
    //     if (c.type == 'HOTSPOT' && c.settings.mediaTrigger) {
    //       c.settings.mediaTrigger = newIds[c.settings.mediaTrigger];
    //     }
    //   });
    //   // fix for dragquestions
    //   newComponents
    //     .filter((c) => c.settings && c.settings.correctDropzone && c.settings.correctDropzone.length)
    //     .forEach((c) => {
    //       if (!c.settings.correctDropzone) return;
    //       c.settings.correctDropzone = c.settings.correctDropzone
    //         .map((dzId) => newIds[dzId])
    //         // just to be safe
    //         .filter((dzId) => dzId);
    //     });
    //   return newComponents;
    // }
})(Component || (exports.Component = Component = {}));
//# sourceMappingURL=Component.js.map